module.exports = __webpack_public_path__ + "static/Motive, ex KeepTruckin-c150860786e1ece1a6da9574ebce0bf2.jpg";